// import shop from '../api/shop'
// import * as types from './mutation-types'

// export const addToCart = ({ commit }, product) => {
//   if (product.inventory > 0) {
//     commit(types.ADD_TO_CART, product.id)
//   }
// }

// export const checkout = ({ commit, state }, products) => {
//   const savedCartItems = [...state.cart.added]
//   commit(types.CHECKOUT_REQUEST)
//   shop.buyProducts(
//     products,
//     () => commit(types.CHECKOUT_SUCCESS),
//     () => commit(types.CHECKOUT_FAILURE, savedCartItems)
//   )
// }

// export const getAllProducts = ({ commit }) => {
//   shop.getProducts(products => {
//     commit(types.RECEIVE_PRODUCTS, products)
//   })
// }
import * as types from './mutation-types'
import { service } from '../service'
// const expSec = 30 * 60

export const initVuex = ({ commit, state }) => {
  commit(types.CLEAR_STUDENTS)
  commit(types.CLEAR_CLASS)
  commit(types.CLEAR_TEACHERS)
  commit(types.CLEAR_CURCHE)
  commit(types.CLEAR_MINE)
  commit(types.CLEAR_STUDENT_PARENTS)
}

export const ajaxFun = ({commit, state}, para, flag, time, type, expSec = 30 * 60) => {
  // 半小时获取一次
  if (flag && new Date().getTime() - time < expSec * 1000) {
    return
  }
  let context = para.context
  let callback = para.callback
  para.context = undefined
  para.callback = undefined
  let obj = {context: context, para: para, successFun: (response) => {
    commit(type, response.data)
    if (callback) {
      callback(response)
    }
  }}
  service.request(obj)
}



// WEBPACK FOOTER //
// ./C:/vue/2.0/src/vuex/actions.js